import { Helmet } from "react-helmet";
import { useLocation } from "react-router";
import LoginLayout from "./login/index";
import MainLayout from "./main";
import SelectCompanyLayout from "./selectCompany";
import UpdateAppWrapper from "components/apps/UpdateAppWrapper";
import { useEffect, useMemo } from "react";
import customAxios, {
  errorHandler,
  // requestHandler,
  successHandler,
} from "utils/axios";
import PublicLayout from "./public/PublicLayout";
import BillingLayout from "./billing";
import { useAntdMessage } from "hooks/useAntdMessage";

const Layouts = {
  login: LoginLayout,
  main: MainLayout,
  selectCompany: SelectCompanyLayout,
  public: PublicLayout,
  billing: BillingLayout,
};

export const Layout = ({ children }) => {
  const { notification } = useAntdMessage();
  const { pathname } = useLocation();

  const layout = useMemo(() => {
    if (pathname === "/p" || pathname.startsWith("/p/")) {
      return "public";
    }

    if (pathname.startsWith("/user/billing")) {
      return "billing";
    }

    if (pathname === "/user/select-company") {
      return "selectCompany";
    }

    if (/^\/user(?=\/|$)/i.test(pathname)) {
      return "login";
    }

    return "main";
  }, [pathname]);

  useEffect(() => {
    // Interceptor untuk menangani setiap respons yang berhasil
    const responseSuccessInterceptor = customAxios.interceptors.response.use(
      successHandler,
      (error) => errorHandler(error, pathname, notification)
    );
    // const requestInterceptor = customAxios.interceptors.request.use(
    //   requestHandler,
    //   (error) => errorHandler(error, pathname)
    // );
    // Membersihkan interceptor saat komponen dibongkar
    return () => {
      customAxios.interceptors.response.eject(responseSuccessInterceptor);
      // customAxios.interceptors.request.eject(requestInterceptor);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const Container = Layouts[layout];

  return (
    <>
      <Helmet titleTemplate="Kledo Support | %s" title="Kledo Software" />
      <Container>{children}</Container>
      <UpdateAppWrapper />
    </>
  );
};

export default Layout;
